import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: 5,
    government: 5,
    office: 10,
  },
  education: {
    childcare: 2,
    high_school: 3,
    library: 5,
    primary: 3,
    university: 10,
  },
  essentials: {
    electricity: 15,
    gas: 10,
    sewers: 5,
    waste: 5,
    water: 10,
  },
  food: {
    bakery: 5,
    coffee: 5,
    fast_food: 5,
    restaurant: 5,
  },
  health: {
    clinic: 8,
    dentist: 5,
    hospital: 5,
    pharmacy: 8,
  },
  nature: {
    beach: 0,
    forest: 0,
    lake: 0,
    mountain: 0,
    park: 5,
    river: 0,
  },
  religion: {
    church: 0,
    mosque: 0,
  },
  shops: {
    grocery: 8,
    mall: 5,
  },
  soil: {
    clay: 0,
    loam: 0,
    peat: 0,
    salt: 0,
    sand: 0,
    silt: 0,
  },
  sport: {
    gym: 5,
    pool: 0,
  },
  telecom: {
    cable_tv: 15,
    fiber_optic: 15,
    network_4g: 15,
    network_5g: 15,
    phone: 15,
  },
  transport: {
    airport: 7,
    bus: 5,
    ferry: 0,
    gas_station: 5,
    metro: 7,
    parking: 7,
    taxi: 7,
    train: 10,
    tram: 5,
  },
};

export default PLACES_PROFILE;
